import { types, Instance } from 'mobx-state-tree';

/**
 * ForceNone means hide visuals indicating change and remaining some time
 */
export enum RateChange { None = 'none', ForceNone = 'forceNone', Up = 'up', Down = 'down' };

export const RateChangeForStore = types.enumeration('RateChangeForStore', [RateChange.None, RateChange.ForceNone, RateChange.Up, RateChange.Down]);


export const TicketSelection = types
    .model({  //see also ITicketStorageSelection
        id: types.string,  // in api it's as Long
        fixtureId: types.number,
        gameId: types.string, // gameId is usually marketType.id, but for marketType with Visualization.NonAggregated it's composition of {marketType.Id}d{market.Id}
        rate: types.number,
        rateAccepted: types.number,
        rateChange: types.maybeNull(RateChangeForStore),
        marketName: types.string,
        tipName: types.string,
        isBanker: types.maybeNull(types.boolean),
        sportName: types.string,
        fixtureName: types.string,
        fixtureDate: types.maybeNull(types.Date),
        errors: types.array(types.string),
        indent: types.string, //TODOHT indent
        number: types.maybeNull(types.number), //for LV aka canShowAlias only
        offerType: types.maybeNull(types.number), //OfferType
        canAnimate: types.optional(types.boolean, false)
    }).actions(
        self => {
            return {
                setIsBanker: (value: boolean): void => {
                    self.isBanker = value;
                }
            }
        }
    );

export type ITicketSelection = Instance<typeof TicketSelection>;